const contextPattern = /\s*(?:\/\s*(?:>\s*)?|>\s*)$/;

export function parseCommandPaletteQuery(value = '') {
  const query = String(value);
  const hasContextToken = contextPattern.test(query);

  return {
    raw: query,
    hasContextToken,
    search: hasContextToken ? query.replace(contextPattern, '').trim() : query.trim(),
  };
}
